import angular from 'angular';
import indicesTable from './indices-table.component';

export default angular.module('eshq.indicesTable', [])
  .component('eshqIndicesTable', indicesTable)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/indices-table/indices-table.js